export const customFileInputLabelStyle = {
    whiteSpace: "nowrap",
    display: "block",
    overflow: "hidden"
  }  
  